import React, { FunctionComponent } from 'react';
import { taskSimpleSelectors } from '../../../../../../app/resource/task-simple/task-simple.selectors';
import { useSelectWithParams } from '../../../../../../utils/selector.utils';
import { ITaskCalendarProps } from './types';

export const TaskCalendar: FunctionComponent<ITaskCalendarProps> = ({ taskId }) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId);

  return (
    task && (
      <div className="calendar-item">
        <div className="calendar-event">
          <div className="calendar-card lightGreen-bg green">
            {task.taskTypeId === '1' ? <i className="icon-flag-checkered" style={{ fontSize: '14px' }}></i> : null}{' '}
            {task.title}
          </div>
        </div>
      </div>
    )
  );
};
